import { useSelectorApp } from "../../lib/redux";
import { Navigate, useLocation } from "react-router-dom";
import { OWNER_ROLE } from "../../utils/constants";

export const OwnerRoute = ({ children, isLogged }) => {
  const location = useLocation();
  const { user } = useSelectorApp((state) => state.auth);

  if (!isLogged) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.role !== OWNER_ROLE) {
    return <Navigate to="/" replace />;
  }

  return children;
};
